export const cardTypes = {
  debit: 'Débito',
  credit: 'Crédito',
  prepaid: 'Pré pago',
};

export const CardStatus = {
  blocked: 'Bloqueado',
  active: 'Ativo',
  inactive: 'Inativo',
  pending: 'Pendente',
};

export const invoiceCardStatus = {
  OPEN: 'Aberta',
  CLOSED: 'Fechada',
  PAID: 'Paga',
  OVERDUE: 'Atrasada',
  CANCELED: 'Cancelada',
};

export const invoiceTransactionStatus = {
  AUTHORIZED: 'Autorizada',
  REFUNDED: 'Estornada',
  CANCELED: 'Cancelada',
};